module.exports = __webpack_public_path__ + "13a75d4dc8da03067ccf35de486c0f28.png";